import { render } from "./IframeGantt.vue?vue&type=template&id=d447c7fe&scoped=true"
import script from "./IframeGantt.vue?vue&type=script&lang=js"
export * from "./IframeGantt.vue?vue&type=script&lang=js"

import "./IframeGantt.vue?vue&type=style&index=0&id=d447c7fe&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d447c7fe"]])

export default __exports__